import { DollarOutlined } from "@ant-design/icons";
import { Button, Checkbox, message, Modal, Select, Space, Tooltip } from "antd"
import { useCallback, useEffect, useMemo, useState } from "react";
import { serverFetch } from "../../server";
import { fmtTime } from "../../extensions/utils";
import Client from "../clients/client";
import dayjs from "dayjs";

/** Оформление визита по смартзаписи */
const RecordSmartVisit = ({onClose, items}) => {
  const [selected, setSelected] = useState(items.filter(i => !i.cnts.find(c => c.objectVid === 1 && c.used)).map(i => i.cnts.filter(i2 => i2.objectVid === 1)[0].id));
  const [loading, setLoading] = useState(false);
  const [abon, setAbon] = useState();
  const [abons, setAbons] = useState([]);
  const [editClient, setEditClient] = useState(false);
  const toggleSelect = (id, checked) => checked ? setSelected([...selected, id]) : setSelected(selected.filter(i => i !== id));

  const client = items[0].cnts.filter(i => i.objectVid === 1)[0];

  /** Нужен абонемент, если среди отмеченных записей есть хотя бы одна с forPayment === false */
  const needsAbonement = useMemo(() => {
    return items.some((i) => {
      const c = i.cnts.find((x) => x.objectVid === 1);
      if (!c || !selected.includes(c.id)) return false;
      return i.forPayment === false;
    });
  }, [items, selected]);

  const loadAbons = useCallback(() => {
    if (!needsAbonement) return;
    serverFetch(`sale/ListByClient/${client.objectId}?vids=2`)
      .then((data) => {
        const newAbons = data.filter((i) => i.status === 2 && !i.deleted).map((i) => ({ label: `[${i.id}] ${i.productName}`, value: i.id }));
        setAbons(newAbons);
        setAbon((prev) => {
          if (newAbons.length === 0) return undefined;
          if (newAbons.some((a) => a.value === prev)) return prev;
          return newAbons[0].value;
        });
      })
      .catch((e) => message.error(e.userMessage));
  }, [needsAbonement, client.objectId]);

  useEffect(() => {
    if (!needsAbonement) {
      setAbons([]);
      setAbon(undefined);
      return;
    }
    loadAbons();
  }, [needsAbonement, loadAbons]);

  const onSave = () => {
    setLoading(true);
    serverFetch("visit/AddByRecords", {
      method: "POST",
      bodyData: { recordCnts: selected, saleId: needsAbonement ? abon : null },
    })
      .then(() => onClose(true))
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  const divVisits = items.filter(i => !i.deleted).map(i => {
    const client = i.cnts.filter(i2 => i2.objectVid === 1)[0];
    return <div className="record-visit-item" key={client.id}>
      <Checkbox checked={selected.includes(client.id)} onChange={e => toggleSelect(client.id, e.target.checked)} disabled={i.cnts.find(c => c.objectVid === 1 && c.used)}>
        {fmtTime(i.start)}-{fmtTime(i.finish)} {i.cnts.filter(i2 => i2.objectVid === 2).map(i2 => i2.objectName).join(", ")}
        {` #${i.id}`}
        {i.forPayment === true && (
          <Tooltip title="За плату">
            <DollarOutlined style={{ marginLeft: 6, color: "#2f6f00", verticalAlign: "middle" }} />
          </Tooltip>
        )}
      </Checkbox>
    </div>
  })  

  // Предупреждение по интервалу времени выбранных записей
  const timeWarning = useMemo(() => {
    const items2 = items.filter(i => selected.includes(i.cnts.filter(i2 => i2.objectVid === 1)[0]?.id));
    if (!items2?.length) return null;
    const minStart = items2.reduce((min, it) => (dayjs(it.start).isBefore(min) ? dayjs(it.start) : min), dayjs(items2[0].start));
    const maxFinish = items2.reduce((max, it) => (dayjs(it.finish).isAfter(max) ? dayjs(it.finish) : max), dayjs(items2[0].finish));
    const now = dayjs();
    if (now.isBefore(minStart)) return "Время записи еще не наступило";
    if (now.isAfter(maxFinish)) return "Время записи уже прошло";
    return null;
  }, [items, selected]);

  return<Modal open onCancel={() => onClose()} footer={null} title="Визит по смартзаписи" loading={loading} closeIcon={!editClient}>
    <div className="record-visit-title">Клиент</div>
    <div className="record-visit-item"><Space><div>{client.objectName}</div><Button onClick={() => setEditClient(true)}>Изменить</Button></Space></div>
    {needsAbonement && (
      <>
        <div className="record-visit-title">Абонемент</div>
        <div className="record-visit-item"><Select style={{ width: "100%" }} options={abons} value={abon} onChange={setAbon} /></div>
      </>
    )}
    <div className="record-visit-title">Услуги</div>
    {divVisits}
    {timeWarning && (
      <div style={{
        marginTop: 12,
        marginBottom: 12,
        padding: 8,
        borderRadius: 4,
        background: "#fffbe6",
        border: "1px solid #ffe58f",
        color: "#ad8b00"
      }}>{timeWarning}</div>
    )}
    <div className="record-visit-footer"><Button disabled={!selected.length || (needsAbonement && !abon)} className="dolg-button" onClick={onSave}>Открыть визит</Button></div>
    {editClient && <Client id={client.objectId} onClose={() => { setEditClient(false); loadAbons(); }} />}
  </Modal>
}

export default RecordSmartVisit;